let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("b96xd")]).then(() => parcelRequire('enM7E'));